import Page from "webPage/Page";
import StyleGallery from "StyleGallery";

import {handleTestimonials} from "util/handleTestimonials";

Page.register('page-template-commercial-blinds', () => {
    let gallery = new StyleGallery($('.js-gallery'));

    handleTestimonials();
});
